"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTypeImage = exports.EntityTypeImageDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_type_icon_1 = require("./entity-type-icon");
exports.EntityTypeImageDefaultProps = {
  iconColor: 'textTag',
  bgColor: 'text',
  aspectRatio: {
    base: 21 / 9,
    tablet: 16 / 9
  },
  iconSize: 200
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  \n  ", "\n\n  ", "\n  "], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  \n  ", "\n\n  ", "\n  "])), function (_a) {
    var bgColor = _a.bgColor;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), theme_1.theme.COLOR(bgColor));
  }, function (props) {
    return props.aspectRatio && props.aspectRatio.base && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.base * 100);
  }),
  landscape: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.landscape && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.landscape * 100);
  }),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.tablet && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.tablet * 100);
  }),
  desktop: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.desktop && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.desktop * 100);
  }),
  desktopLarge: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.desktopLarge && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.desktopLarge * 100);
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    overflow: hidden;\n  "], ["\n    overflow: hidden;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Icon: (0, styled_components_1.default)(entity_type_icon_1.EntityTypeIcon)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var EntityTypeImage = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    iconColor = props.iconColor,
    iconSize = props.iconSize,
    bgColor = props.bgColor,
    aspectRatio = props.aspectRatio;
  return react_1.default.createElement(My.Container, {
    bgColor: bgColor,
    aspectRatio: aspectRatio,
    className: className
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Icon, {
    size: iconSize,
    entityTypeName: entityTypeName,
    color: iconColor
  })));
};
exports.EntityTypeImage = EntityTypeImage;
exports.EntityTypeImage.defaultProps = exports.EntityTypeImageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;